module.exports = __webpack_public_path__ + "static/media/ic-callkit-video-on.0021ea2d.webp";